import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\">\n    <title>icon/基础图标/关闭</title>\n    <g id=\"icon-close_icon/基础图标/关闭\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\" stroke-linejoin=\"round\">\n        <line x1=\"77.7926054\" y1=\"18.000695\" x2=\"18.7449863\" y2=\"77.048314\" id=\"icon-close_路径-2备份-2\" stroke=\"#2C2C2E\" stroke-width=\"10\" />\n        <line x1=\"76.8402244\" y1=\"78.000695\" x2=\"17.7926054\" y2=\"18.9530759\" id=\"icon-close_路径-2备份-3\" stroke=\"#2C2C2E\" stroke-width=\"10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close.svg
// module id = toIl
// module chunks = 3